module.exports = __webpack_public_path__ + "img/bg.5e6b4c0f.png";